<div
  class="review-coupon-code"
  [class.review-coupon-code--success]="isSuccess()"
  [class.review-coupon-code--invalid]="isInvalid()"
  data-testid="review-coupon"
>
  <puro-typography component="p" variant="body1" class="review-coupon-code__title">
    {{ 'createShipment.reviewAndPay.estimate.couponTitle' | translate }}
  </puro-typography>
  <div class="review-coupon-code__row">
    <puro-input
      class="review-coupon-code__input"
      [class.review-coupon-code__input--success]="isSuccess()"
      [class.review-coupon-code__input--invalid]="isInvalid()"
      [formControl]="couponControl()"
      [label]="'createShipment.reviewAndPay.estimate.couponPlaceholder' | translate"
      [fullWidth]="true"
      [error]="isInvalid()"
      [errorMessage]="
        isInvalid() ? ('createShipment.reviewAndPay.estimate.couponInvalid' | translate) : ''
      "
      [success]="isSuccess()"
      [successMessage]="
        isSuccess() ? ('createShipment.reviewAndPay.estimate.couponAppliedSuccess' | translate) : ''
      "
      [endAdornment]="isInvalid() || isSuccess()"
      data-testid="review-coupon-input"
    >
      @if (isInvalid()) {
        <span endAdornment class="review-coupon-code__status-icon">
          <img
            src="assets/icons/alert-red.svg"
            alt=""
            aria-hidden="true"
            width="16"
            height="16"
            data-testid="review-coupon-invalid-icon"
          />
        </span>
      }
      @if (isSuccess()) {
        <span endAdornment class="review-coupon-code__status-icon">
          <img
            src="assets/icons/success-validated.svg"
            alt=""
            aria-hidden="true"
            width="16"
            height="16"
            data-testid="review-coupon-success-icon"
          />
        </span>
      }
    </puro-input>
    <puro-button
      type="button"
      variant="primary"
      size="large"
      data-testid="review-coupon-apply"
      [disabled]="isBusy()"
      [attr.aria-label]="'createShipment.reviewAndPay.estimate.applyAria' | translate"
      (buttonClick)="onApply()"
    >
      {{ 'createShipment.reviewAndPay.estimate.apply' | translate }}
    </puro-button>
  </div>
</div>
